import { Button } from "@mui/material";

const CancelAppointmentButton = ({
  setOpenCancelDialog,
}: {
  setOpenCancelDialog: (openCancelDialog: boolean) => void;
}): React.JSX.Element => (
  <Button
    fullWidth
    variant="contained"
    color="secondary"
    onClick={() => setOpenCancelDialog(true)}
  >
    Stornieren
  </Button>
);

export default CancelAppointmentButton;
